import { typographyToCss } from 'shared/lib/mui';
import styled from 'styled-components';

export const EventContainer = styled.div`
  ${({ theme }) => typographyToCss(theme.typography.caption)};
  background: ${({ theme }) => theme.palette.primary.main};
`;
